import ProfileCardClient from '@atlaskit/profilecard/client';

const DIRECTORY_URL = '/gateway/api/directory/graphql';
const ATLAS_URL = '/gateway/api/watermelon/graphql';

export const profileCardClient = new ProfileCardClient({
  url: DIRECTORY_URL,
  productIdentifier: 'confluence',
});
profileCardClient.getTeamCentralBaseUrl = async () => ATLAS_URL;
profileCardClient.shouldShowGiveKudos = async () => false;
